import React from 'react';

function HeroBanner({
	props: {
		image,
		imageMobile,
		imageTablet,
		imageUrl,
		imageUrlMobile,
		imageUrlTablet,
		title,
	},
	fullScreen,
}) {
	let mainImage = imageUrl || null,
		mainImageTitle = title,
		mobileImage = imageUrlMobile || null,
		mobileImageTitle = title,
		tabletImage = imageUrlTablet || null,
		tabletImageTitle = title;

	if (!mainImage && image?.fields?.file?.url) {
		mainImage = image?.fields?.file?.url;
		mainImageTitle = image?.fields?.title;
	}

	if (!mobileImage && imageMobile?.fields?.file?.url) {
		mobileImage = imageMobile?.fields?.file?.url;
		mobileImageTitle = imageMobile?.fields?.title;
	}

	if (!tabletImage && imageTablet?.fields?.file?.url) {
		tabletImage = imageTablet?.fields?.file?.url;
		tabletImageTitle = imageTablet?.fields?.title;
	}

	let content = (
		<>
			<img
				src={mainImage}
				alt={mainImageTitle}
				title={mainImageTitle}
				className={`${
					mobileImage || tabletImage
						? 'd-none d-lg-inline-block'
						: 'd-inline-block'
				} mw-100`}
			/>
			{tabletImage && (
				<img
					src={tabletImage}
					alt={tabletImageTitle}
					title={tabletImageTitle}
					className='d-none d-sm-inline-block d-lg-none mw-100'
				/>
			)}
			{mobileImage && (
				<img
					src={mobileImage}
					alt={mobileImageTitle}
					title={mobileImageTitle}
					className='d-inline-block d-sm-none mw-100'
				/>
			)}
		</>
	);

	if (image?.fields?.description) {
		content = (
			<a className='d-block' href={image?.fields?.description}>
				{content}
			</a>
		);
	}

	if (!fullScreen) {
		content = <div className='container'>{content}</div>;
	}

	return content;
}

export default HeroBanner;
